import { DetailsOpenStatusByTraveler } from 'src/common/interface';
/**
 * CheckinReview model details
 */
export interface CheckinReviewStateDetails {}

/**
 * CheckinReview store state
 */
export interface CheckinReviewState extends CheckinReviewStateDetails {
  model: DetailsOpenStatusByTraveler;
}

/**
 * Name of the CheckinReview Store
 */
export const CHECKIN_REVIEW_STORE_NAME = 'checkinReview';

/**
 * CheckinReview Store Interface
 */
export interface CheckinReviewStore {
  /** CheckinReview state */
  [CHECKIN_REVIEW_STORE_NAME]: CheckinReviewState;
}
